'use strict';

angular.module('internal.investigations')
    .directive('internalInvestigationNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'investigations/components/investigation-navigation/investigation-navigation.html',
            replace: true,
            controller: 'InternalNavigation'
        };
    }])
;